import { useCallback, useState } from "react";
import styles from "./Form.module.css";
import {
    Header,
    HeaderBrand,
    HeaderLogotypeSecondary,
    Logotype,
    Step,
    Stepper,
} from "@volvo/vcdk-react";
import { HeaderLogotypePrimary } from "@volvo/vcdk-react/HeaderLogotypePrimary";
import RequestForm from "./Common/RequestForm/RequestForm";
import { FORM_STEPS, STEP_STATUS } from "../constants/const";

const Form = () => {
    const [isBrandSelected, setIsBrandSelected] = useState<boolean>(false);

    const handleBrandSelected = useCallback(() => {
        setIsBrandSelected(true);
        return true;
    }, []);

    const brandStepStatus = isBrandSelected
        ? STEP_STATUS.Completed
        : STEP_STATUS.Current;
    const requestStepStatus = isBrandSelected
        ? STEP_STATUS.Current
        : STEP_STATUS.NotCompleted;

    return (
        <div>
            <div className={styles.Header}>
                <Header>
                    <HeaderBrand>
                        <HeaderLogotypePrimary logotype="volvo-spread-word-mark" />
                        <HeaderLogotypeSecondary>
                            <Logotype variant="renault-trucks-horizontal" />
                        </HeaderLogotypeSecondary>
                    </HeaderBrand>
                </Header>

                <Stepper className={styles.Stepper}>
                    <Step
                        stepNo={1}
                        label={FORM_STEPS.SignUp}
                        status={STEP_STATUS.Completed}
                    />
                    <Step
                        stepNo={2}
                        label={FORM_STEPS.Brand}
                        status={brandStepStatus}
                    />
                    <Step
                        stepNo={3}
                        label={FORM_STEPS.Request}
                        status={requestStepStatus}
                    />
                </Stepper>

                <div>
                    <RequestForm onBrandSelected={handleBrandSelected} />
                </div>
            </div>
        </div>
    );
};

export default Form;
